import { useEffect, useRef, useState } from 'react';
import { countUpFrame, countUpProgress } from '@/utils/countUp';

const reducedMotion = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

export default function useCountUp(targets) {
    const [values, setValues] = useState(null);
    const fromRef = useRef(null);
    const frameRef = useRef(null);
    const key = targets ? targets.join('|') : '';

    useEffect(() => {
        if (!targets) {
            fromRef.current = null;
            setValues(null);

            return;
        }

        if (reducedMotion()) {
            fromRef.current = targets;
            setValues(targets);

            return;
        }

        // A refetch (guest count edited) counts from the figures already on
        // screen, so only the first reveal runs up from zero.
        const from =
            fromRef.current?.length === targets.length ? fromRef.current : [];
        const start = performance.now();

        const step = (now) => {
            const progress = countUpProgress(now - start);
            const next = countUpFrame(from, targets, progress);

            fromRef.current = next;
            setValues(next);

            if (progress < 1) frameRef.current = requestAnimationFrame(step);
        };

        frameRef.current = requestAnimationFrame(step);

        return () => cancelAnimationFrame(frameRef.current);
    }, [key]);

    return values;
}
